import { render } from "./DetailTable.vue?vue&type=template&id=484ff610"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__